import { $Q } from './query-selector';

/**
 *
 * @param {DOM element} node
 * it will set data-active attr to false to the DOM element, if the click event is in another dom element.
 */
export default function onClickOutsideNode(node, callback = null, isModalCart) {
  document.addEventListener('click', function (e) {
    const activeNode = $Q(node);
    const activeNodeInner = $Q('.modal-cart-inner');
    const overlay = $Q('#overlay--modal-wrapper');

    if (!activeNode || !overlay) return;
    
    if (overlay.contains(e.target)) {
      activeNode.setAttribute('data-active', 'false');

      if(isModalCart) {
        activeNodeInner.innerHTML = '';
      }
    }
  });
}
